// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Square(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Square" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M4 4H20V20H4V4Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Square.js.map